import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import Pagination from '../../components/pagination/pagination';
import SubuserInvoiceAdminViewTable from "../../components/subuserInvoiceAdminViewTable";
import ViewLayout from "../../components/viewLayout";
import { useFetch } from "../../utils/fetchHook";
import { getCookie } from "../../jwt/_helpers/cookie";
import TableHelper from "../../components/tableHelper";
import {  Alert, Modal, ModalHeader, ModalFooter, ModalBody, Button } from "reactstrap";
import TenantContext from "../../utils/tenantContext";
import { Link } from "react-router-dom";
import { StateContext } from "../../utils/context";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const SubuserInvoicesAdminView = () => {
  const token = getCookie("token");
  const { currentUser } = useContext(StateContext);
  const {tenant} = useContext(TenantContext);

  const [subuserInvoicesEnabled, setSubuserInvoicesEnabled] = useState(false);

  const didEff1 = useRef(false);
  const didEff2 = useRef(false);

  const [forceUpdate, setForce] = useState(1);
  const [dataCount, setDataCount] = useState(0);
  const [currrentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [ordering, setOrdering] = useState({order: '-', name: 'issue_date', sort: 'issue_date'});
  const [subUser, setSubUser] = useState('');
  const [subUserEndpoint, setSubUserEndpoint] = useState('');
  const [subusersUserOnly, setSubusersOnly] = useState('&subusers_only=true');

  const [apiData, error, loading] = useFetch("GET", `subuser-invoices/${subUserEndpoint}?ordering=${ordering.order + ordering.name}&page=${currrentPage}&page_size=${pageSize}&search=${query}${subusersUserOnly}`, token, false, forceUpdate);
  const [tableData, setTableData] = useState([]);

  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  const [success, setSuccess] = useState(false);
  const [errorPut, setErrorPut] = useState(false);

  useEffect(() => {
    if (tenant && tenant.invoices_enabled) {
      setSubuserInvoicesEnabled(true);
    }
  }, [tenant]);

  useEffect(() => {
    if (!apiData || Array.isArray(apiData)) {
      return;
    }
    setTableData(Array.isArray(apiData.results) ? apiData.results : []);
    setDataCount(typeof apiData.count === "number" ? apiData.count : 0);
  }, [apiData]);

  useEffect(() => {
    if (!didEff1.current) {
      didEff1.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [currrentPage, pageSize, ordering.order, ordering.name, subUser]);


  useEffect(() => {
    if (!didEff2.current) {
      didEff2.current = true;
      return;
    }
    const timeout = setTimeout(() => {
      setForce(prev => prev + 1);
    }, 500)
    return () => clearTimeout(timeout)
  }, [query])

  const paginationProps = {
    pageSize, setPageSize, dataCount, setCurrentPage, currrentPage
  }

  const defaultSorted = [{
    dataField: ordering.sort,
    order: ordering.order === "-" ? "desc" : "asc"
  }] 

  const tableProps = {
    tableData,
    defaultSorted
  };

  const tokenAPI = getCookie("token");

  const handleUpdate = () => {
    const options = {
      method: "POST",
      data: dataModal,
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${tokenAPI}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    };

    axios(`${API_URL}subuser-invoices/update-invoice-status/`, options)
      .then(res => {
        setToggleModal(false);
        setSuccess(true);
        setForce(forceUpdate + 1);
      })
      .catch(err => {
        setErrorPut(true);
      });
  };

  return (
    <>
      {      
        loading ? (
          <TableHelper loading />
        ) : error ? (
          <TableHelper error />
        ) : (
        <div>
          { (!subuserInvoicesEnabled) &&
            <Alert color="warning">
              Subuser invoices are offered with <Link to="/sla">Gold Plan SLA</Link> only. Please <Link to="/sla">upgrade your account</Link> in order to avail this feature.
            </Alert>
          }
          <ViewLayout title={"Subuser Invoices list"}>
            <SubuserInvoiceAdminViewTable
              {...tableProps}
              searchQuery={{setQuery, query, ordering, setOrdering}}
              subUserData={{subUser, setSubUser, subUserEndpoint, setSubUserEndpoint, setSubusersOnly}}
              setToggleModal={setToggleModal}
              setDataModal={setDataModal}
              disabled={!subuserInvoicesEnabled}
              currentUser={currentUser}
            />
          </ViewLayout>
          <Pagination pagination={paginationProps}/>
        </div>
      )}
      {success && <Alert color="success">Invoice status has been updated!</Alert>}
      {errorPut && <Alert color="danger">Something went wrong! Please refresh page and try again!</Alert>}

      <Modal isOpen={openModal} centered={true}>
        <ModalHeader>Update Invoice Status</ModalHeader>
        {dataModal && <ModalBody>Are you sure you want to update the status of the invoice to <strong>{dataModal.status === 1 ? "Accepted" : dataModal.status === 2 ? "Rejected" : dataModal.status === 3 ? "Paid" : ""}</strong>?</ModalBody>}
        <ModalFooter>
          <Button color="secondary" onClick={() => setToggleModal(false)}>
            Cancel
          </Button>
          <Button color="success" onClick={() => handleUpdate()}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SubuserInvoicesAdminView;
